import styled from 'styled-components';
import {getFontSize} from '@ey/canvascoreservices';

export default styled.div`
	.motif-icon-button {
		padding: 0;
		margin-left: auto;
		.motif-icon svg {
			color: var(--ib-color);
			height: var(--px-16) !important;
    		width: var(--px-16) !important;
		}

		
		&:hover {
			.motif-icon svg {
				color: var(--ib-hover-color);
			}
		}
		.ib-label {
			${getFontSize('L')}
			font-weight: 700;
		}
	}

`;
